var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPalette = function SvgPalette(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 5.33325C1.33325 3.12411 3.12411 1.33325 5.33325 1.33325H10.6666C12.8757 1.33325 14.6666 3.12411 14.6666 5.33325V21.3333C14.6666 23.5424 12.8757 25.3333 10.6666 25.3333H5.33325C3.12411 25.3333 1.33325 23.5424 1.33325 21.3333V5.33325ZM5.33325 3.99992C4.59687 3.99992 3.99992 4.59687 3.99992 5.33325V21.3333C3.99992 22.0696 4.59687 22.6666 5.33325 22.6666H10.6666C11.403 22.6666 11.9999 22.0696 11.9999 21.3333V5.33325C11.9999 4.59687 11.403 3.99992 10.6666 3.99992H5.33325Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55229 23.5999C3.51089 22.5585 3.51089 20.8701 4.55229 19.8287L17.8287 6.55229C18.8701 5.51089 20.5585 5.51089 21.5999 6.55229L25.4477 10.4001C26.4891 11.4415 26.4891 13.1299 25.4477 14.1713L12.1713 27.4477C11.1299 28.4891 9.4415 28.4891 8.4001 27.4477L4.55229 23.5999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6572 7.49518C20.1365 6.97448 19.2923 6.97448 18.7716 7.49518L5.49518 20.7716C4.97448 21.2923 4.97448 22.1365 5.49518 22.6572L9.34299 26.505C9.86369 27.0257 10.7079 27.0257 11.2286 26.505L24.505 13.2286C25.0257 12.7079 25.0257 11.8637 24.505 11.343L20.6572 7.49518ZM16.8859 5.60956C18.448 4.04746 20.9807 4.04746 22.5428 5.60956L26.3906 9.45737C27.9527 11.0195 27.9527 13.5521 26.3906 15.1142L13.1142 28.3906C11.5521 29.9527 9.01947 29.9527 7.45737 28.3906L3.60956 24.5428C2.04746 22.9807 2.04746 20.448 3.60956 18.8859L16.8859 5.60956Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 21.3334C2.66675 19.8607 3.86066 18.6667 5.33341 18.6667H26.6667C28.1395 18.6667 29.3334 19.8607 29.3334 21.3334V26.6667C29.3334 28.1395 28.1395 29.3334 26.6667 29.3334H5.33342C3.86066 29.3334 2.66675 28.1395 2.66675 26.6667V21.3334Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 21.3333C1.33325 19.1241 3.12411 17.3333 5.33325 17.3333H26.6666C28.8757 17.3333 30.6666 19.1241 30.6666 21.3333V26.6666C30.6666 28.8757 28.8757 30.6666 26.6666 30.6666H5.33325C3.12411 30.6666 1.33325 28.8757 1.33325 26.6666V21.3333ZM5.33325 19.9999C4.59687 19.9999 3.99992 20.5969 3.99992 21.3333V26.6666C3.99992 27.403 4.59687 27.9999 5.33325 27.9999H26.6666C27.403 27.9999 27.9999 27.403 27.9999 26.6666V21.3333C27.9999 20.5969 27.403 19.9999 26.6666 19.9999H5.33325Z",
    fill: "#8290A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 26C9.10457 26 10 25.1046 10 24C10 22.8954 9.10457 22 8 22C6.89543 22 6 22.8954 6 24C6 25.1046 6.89543 26 8 26Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPalette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/palette.3225a58d.svg";
export { ForwardRef as ReactComponent };